import analytics from "../analytics/analytics.js";
const FEEDBACK_URL = 'https://qaa.priceline.com/genai-svc/genai/chat/feedback';
const feedbackPost = async (args, url, headers)=>{
    const abortController = new AbortController();
    const timeoutId = setTimeout(()=>{
        abortController.abort();
    }, 30000);
    try {
        const res = await fetch(url || FEEDBACK_URL, {
            method: 'POST',
            body: JSON.stringify(args),
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                ...headers
            },
            signal: abortController.signal
        });
        clearTimeout(timeoutId);
        return await res.json();
    } catch (e) {
        const { cguid, conversationId, message, feedbackId } = args;
        analytics.log({
            message: 'Failed to submit Feedback',
            cguid,
            conversationId,
            content: message.content,
            vote: message.vote,
            feedbackId
        });
    }
};
export { feedbackPost };
